export const IDLE_TIMEOUT_MS: number = 60 * 60 * 1000;
export const IDLE_CHECK_INTERVAL_MS: number = 30 * 1000;
export const ACTIVITY_THROTTLE_MS: number = 30 * 1000;
export const LAST_ACTIVITY_KEY = 'lastActivityTimestamp' as const;
